import React, { useEffect } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';

const Locale = ({ children }) => {
  const setLanguage = async (locale) => {
    const { messages } = await import(`../locales/${locale}.js`);
    i18n.load(locale, messages);
    i18n.activate(locale);
  };

  useEffect(() => {
    if (localStorage?.getItem('curLang')) {
      setLanguage(localStorage?.getItem('curLang'));
    } else {
      setLanguage('en-US');
    }
  }, []);
  return (
    <I18nProvider forceRenderOnLocaleChange={true} i18n={i18n}>
      {children}
    </I18nProvider>
  );
};

export default Locale;
